<template>
  <button
    class="toggle-icon"
    @click="toggle">
    <img
      class="toggle-icon__img"
      :src="showIcon"
      :style="rotateIcon" />
  </button>
</template>

<script>
  export default {
    data() {
      return {
        toggled: false,
      };
    },
    computed: {
      realToggled() {
        return this.overrideToggle ? this.overrideToggle : this.toggled;
      },
      rotateIcon() {
        if(!this.realToggled) {
          return;
        }
        // eslint-disable-next-line consistent-return
        return {
          transform: `rotate(${this.rotate}deg)`,
        };
      },
      showIcon() {
        return this.realToggled
          ? this.toggledState.icon || this.defaultState.icon
          : this.defaultState.icon;
      },
    },
    props: {
      defaultState: {
        default: () => {
          return {
            icon: false,
          };
        },
        type: Object,
      },
      overrideToggle: {
        default: null,
        type: Boolean,
      },
      rotate: {
        default: 0,
        type: Number,
      },
      toggledState: {
        default: () => {
          return {
            icon: null,
          };
        },
        type: Object,
      },
    },
    methods: {
      toggle() {
        this.toggled = !this.toggled;
      },
    },
  };
</script>

<style lang="less" scoped>
  @iconWidth: 15px;

  .toggle-icon {
    width: @iconWidth;

    &__img {
      height: 15px;
      vertical-align: middle;
      width: @iconWidth;
    }
  }
</style>
